import axios from './_axios'

export const getGuia = _id => axios.get(`/api/guias-compra/${_id}`)
export const getGuias_ParaCompra = idSocio =>
  axios.get('/api/guias-compra', {
    params: {
      tipoConsulta: 'slim',
      idSocio: idSocio
    }
  })

export const getDetalles_ParaCompra = ids => axios.post('/api/guias-compra/info-compra', { ids })

export const actualizarGuia = (_id, data) => axios.put(`/api/guias-compra/${_id}`, data)

export const nuevaGuia = data => axios.post('/api/guias-compra/nuevo', data)

export const eliminarGuia = _id => axios.delete(`/api/guias-compra/${_id}`)
